export default "__VITE_ASSET__20471042__"